import React from 'react';
import './Login.css';
import { connect } from 'react-redux';
import { login, tokenLogin,acceptTerms,disagreeTerms } from '../actions';
import Modal from './Modal';
import jwt from 'jwt-decode';
import axios from "axios";
import TermsOfUse from './TermsOfUse';
import { Redirect } from 'react-router-dom';
import { getStoredToken } from '../utils/getStoredToken';
import { getUserType } from '../utils/getUserType';
import { Alert, Button, Card, Form, Spinner } from 'react-bootstrap';

class Login extends React.Component {
  constructor(props) {
    super(props);
  this.state = {
    displayModal: false,
    errorMessage:'',
    isLoading: false,
    disabled: false,
    logInError: '',
    username: '',
    password: '',
    emptyUsernameError: false,
    emptyPasswordError: false,
    border: "1px solid #ff00007a",
    imageUrl: "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABZ0RVh0Q3JlYXRpb24gVGltZQAxMC8yOS8xMiKqq3kAAAAcdEVYdFNvZnR3YXJlAEFkb2JlIEZpcmV3b3JrcyBDUzVxteM2AAABHklEQVRIib2Vyw6EIAxFW5idr///Qx9sfG3pLEyJ3tAwi5EmBqRo7vHawiEEERHS6x7MTMxMVv6+z3tPMUYSkfTM/R0fEaG2bbMv+Gc4nZzn+dN4HAcREa3r+hi3bcuu68jLskhVIlW073tWaYlQ9+F9IpqmSfq+fwskhdO/AwmUTJXrOuaRQNeRkOd5lq7rXmS5InmERKoER/QMvUAPlZDHcZRhGN4CSeGY+aHMqgcks5RrHv/eeh455x5KrMq2yHQdibDO6ncG/KZWL7M8xDyS1/MIO0NJqdULLS81X6/X6aR0nqBSJcPeZnlZrzN477NKURn2Nus8sjzmEII0TfMiyxUuxphVWjpJkbx0btUnshRihVv70Bv8ItXq6Asoi/ZiCbU6YgAAAABJRU5ErkJggg==)",
    termsAccepted: null,
    termsAcceptedAt: 0,
    isTokenPresent: false,
    userType: null,
    showTncBox: false,
    termOpen:false,
    userId:null,
    // groupId: sessionStorage.getItem('imark-groupId')
  }

  }
 
closeModal = () => {
  this.setState({ termOpen: false });
  console.log('closemodel',this.setState.displayModal)
}
openModal=()=>{
  this.setState({ termOpen: true });
  console.log('openmodal',this.setState.displayModal)
}

  componentDidMount(){
    // if(localStorage.hasOwnProperty('token')){
    //   this.props.history.push('/');
    // }
   
    // console.log('first check groupid',sessionStorage.getItem('imark-groupId'),localStorage.get('imark-groupId'))
    if(this.props.location.search != ''){
    var searchParams = new URLSearchParams(this.props.location.search);
    console.log('searchParams', searchParams);
    
    console.log('SSO Paramter', searchParams.get('token'));

    if(searchParams.get('token')) {
      localStorage.clear();
      this.props.ssoLoginAPI(decodeURIComponent(searchParams.get('token'))).then(res => {
        // if(res.status === 200){

          console.log('check response only',res);
          console.log("chkkkkkkkthissssssssssssssss",res.data.groupId);
          let userInfo = jwt(res.data.jwtToken);
          userInfo.roleTest="Vendor";
          localStorage.setItem("flag","1");
          localStorage.setItem('imark-token', `Bearer ${res.data.jwtToken}`);
           localStorage.setItem("imark-userType", res.data.userType);
           localStorage.setItem("imark-userId", res.data.userId);
           localStorage.setItem("imark-userInfo",JSON.stringify(userInfo));
           localStorage.setItem("imark-groupId",res.data.groupId);
           localStorage.setItem("imark-Name",res.data.firstName);
           localStorage.setItem("imark-termAccepted",res.data.termsAccepted)
           localStorage.setItem("imark-buyingGroupId", res.data.buyingGroupId);
             localStorage.setItem("imark-memberId", res.data.groupId);
             localStorage.setItem("imark-vendorId", res.data.groupId);
           sessionStorage.setItem('imark-token', `Bearer ${res.data.jwtToken}`);
           sessionStorage.setItem("imark-buyingGroupId", res.data.buyingGroupId);
             sessionStorage.setItem("imark-memberId", res.data.groupId);
             sessionStorage.setItem("imark-vendorId", res.data.groupId);
             sessionStorage.setItem("imark-groupId",res.data.groupId);
             sessionStorage.setItem("imark-memberName", res.data.groupName);
             sessionStorage.setItem("imark-vendorName", res.data.groupName);
             sessionStorage.setItem("imark-termAccepted",res.data.termsAccepted)
           axios.defaults.headers.common['Authorization'] = "Bearer " + res.data.jwtToken;
          
          //  this.props.history.push('/');
      //   }
      // else{
      //     this.setState({ errorMessage:res.message });
      //   }
      if (res.data.termsAccepted != null) {
        this.setState({
          termOpen: false,
          isLogging: false,
          userType:res.data.userType,
          userId:res.data.userId,
          // groupId:sessionStorage.getItem('imark-groupId')
        }, () => {
            console.log(this.state.groupId, 'dealersOverallTotal1');
            console.log('sso termaccepted if not null calling',this.state.termOpen,this.state.isLogging,this.state.userType,this.state.userId,this.state.groupId)

          });
    } else {
        this.setState({
          termOpen: true,
          isLogging: false,
          userType:res.data.userType,
          userId:res.data.userId,
          // groupId:sessionStorage.getItem('imark-groupId')
        }, () => {
            console.log(this.state.groupId, 'dealersOverallTotal1');
            console.log('sso termaccepted if equal to null calling',this.state.termOpen,this.state.isLogging,this.state.userType,this.state.userId,this.state.groupId)

          });
    }
      }).catch((err) => {
        console.log(err);
        if (err && err.response && err.response.status) {
            if (err.response.status === 403) {
                this.setState({
                    isLoading: false,
                    errMessage: 'You`re not authorized! Please signup.'
                })
                return this.props.history.push('/');
            }
        } else if (err && err.message) {
            if (err.message === 'Network Error') {
                this.setState({
                    isLoading: false,
                    errMessage: 'Please check your internet connection or try logging in with credentials!'
                })
                return this.props.history.push('/');
            };
        } else {
            if (err) {
                return this.props.history.push('/');
            }
        }
    });
    }
  }
  else{
    var searchParams = new URLSearchParams(window.location.search);
    console.log('searchParams', searchParams);
    console.log('SSO Paramter', searchParams.get('token'));

    if(searchParams.get('token')) {
      localStorage.clear();
      this.props.ssoLoginAPI(decodeURIComponent(searchParams.get('token'))).then(res => {
        // if(res.status === 200){

          console.log('check response only',res);
          console.log("chkkkkkkkthissssssssssssssss",res.data.groupId);
          let userInfo = jwt(res.data.jwtToken);
          userInfo.roleTest="Vendor";
          localStorage.setItem("flag","1");
          localStorage.setItem('imark-token', `Bearer ${res.data.jwtToken}`);
           localStorage.setItem("imark-userType", res.data.userType);
           localStorage.setItem("imark-userId", res.data.userId);
           localStorage.setItem("imark-userInfo",JSON.stringify(userInfo));
           localStorage.setItem("imark-groupId",res.data.groupId);
           localStorage.setItem("imark-Name",res.data.firstName);
           sessionStorage.setItem('imark-token', `Bearer ${res.data.jwtToken}`);
           sessionStorage.setItem("imark-buyingGroupId", res.data.buyingGroupId);
             sessionStorage.setItem("imark-memberId", res.data.groupId);
             sessionStorage.setItem("imark-vendorId", res.data.groupId);
             localStorage.setItem("imark-buyingGroupId", res.data.buyingGroupId);
             localStorage.setItem("imark-memberId", res.data.groupId);
             localStorage.setItem("imark-vendorId", res.data.groupId);
             sessionStorage.setItem("imark-groupId",res.data.groupId);
             sessionStorage.setItem("imark-memberName", res.data.groupName);
             sessionStorage.setItem("imark-vendorName", res.data.groupName);
           axios.defaults.headers.common['Authorization'] = "Bearer " + res.data.jwtToken;

          //  this.props.history.push('/');
        // }
      // else{
      //     this.setState({ errorMessage:res.message });
      //   }
      if (res.data.termsAccepted !== null) {
        this.setState({
          termOpen: false,
          isLogging: false,
          userType:res.data.userType,
          userId:res.data.userId,
          // groupId:sessionStorage.getItem('imark-groupId')
        }, () => {
            console.log(this.state.userId, 'dealersOverallTotal1');
            console.log('sso termaccepted if not null calling',this.state.termOpen,this.state.isLogging,this.state.userType,this.state.userId,this.state.groupId)

          });
    } else {
        this.setState({
          termOpen: true,
          isLogging: false,
          userType:res.data.userType,
          userId:res.data.userId,
          // groupId:sessionStorage.getItem('imark-groupId')
        }, () => {
            console.log(this.state.userId, 'dealersOverallTotal1');
            console.log('sso termaccepted if equal null calling',this.state.termOpen,this.state.isLogging,this.state.userType,this.state.userId,this.state.groupId)

          });
    }
      }).catch((err) => {
        console.log(err);
        if (err && err.response && err.response.status) {
            if (err.response.status === 403) {
                this.setState({
                    isLoading: false,
                    errMessage: 'You`re not authorized! Please signup.'
                })
                return this.props.history.push('/');
            }
        } else if (err && err.message) {
            if (err.message === 'Network Error') {
                this.setState({
                    isLoading: false,
                    errMessage: 'Please check your internet connection or try logging in with credentials!'
                })
                return this.props.history.push('/');
            };
        }else{
            if (err) {
                return this.props.history.push('/');
            }
        }
      });
    }
  }
  }


  // logIn = (e) => {

  //   e.preventDefault();
  //   const { username, password } = this.state;
  //   if (password && username) {
  //     this.setState({ isLoading: true, disabled: true });
  //     this.props.loginAPI({
  //       username: this.state.username,
  //       password: this.state.password
  //     }, (res, err) => {
  //       if (res) {
  //         if(res.status === 200 ){
  //           this.setState.termsAccepted=res.data.termsAccepted
  //           this.setState.userType=res.data.userType
  //           console.log('response if',res.data,this.setState.termsAccepted,this.setState.userType);

  //           console.log("chkkkthissssssssssss2",res.data.groupId)
  //           let userInfo = jwt(res.data.jwtToken)
  //           userInfo.roleTest="Vendor";
  //            localStorage.setItem("imark-token", res.data.jwtToken);
  //            console.log("imark-token",localStorage.getItem("imark-token"));
  //            localStorage.setItem("flag","1");
  //            localStorage.setItem("imark-userType", res.data.userType);
  //            localStorage.setItem("imark-userInfo",JSON.stringify(userInfo));
  //            localStorage.setItem("imark-groupId",res.data.groupId);
  //            localStorage.setItem("imark-userId", res.data.userId);
  //            localStorage.setItem("imark-Name",res.data.firstName);
  //            localStorage.setItem("imark-termAccepted",res.data.termsAccepted)
  //            sessionStorage.setItem("imark-buyingGroupId", res.data.buyingGroupId);
  //            sessionStorage.setItem("imark-memberId", res.data.groupId);
  //            sessionStorage.setItem("imark-vendorId", res.data.groupId);
  //            localStorage.setItem("buyingGroupId", res.data.buyingGroupId);
  //            localStorage.setItem("imark-memberId", res.data.groupId);
  //            localStorage.setItem("imark-vendorId", res.data.groupId);
  //            sessionStorage.setItem("imark-memberName", res.data.groupName);
  //            sessionStorage.setItem("imark-vendorName", res.data.groupName);
  //            sessionStorage.setItem("imark-termAccepted",res.data.termsAccepted)
  //            console.log('localStorage',localStorage);
  //            console.log('flag',localStorage.getItem('flag'));
  //            //axios.defaults.headers.common['Authorization'] = "Bearer " + res.token;
  //            axios.defaults.headers.common['Authorization'] = "Bearer " + res.data.jwtToken;
  //            this.props.history.push('/');



  //            console.log('login check qwertyu',this.state.termOpen, this.state.userType,res.data.termsAccepted)


  //          }


  //       //   else if (res.status === 200 && res.data.credentialsNonExpired == false) {
  //       //     //if (res.status = 200){
  //       //   // window.location = ("/https://bluehawk.tredence.com/reset" );

  //       //   window.location = (document.title, '/' + '#/change/');
  //       //  } else{

  //       //     this.setState({ errorMessage:res.text });
  //       //   }

  //       } else if (err) {

  //         this.setState({ errorMessage:"Error while logging , please provide correct credentials" });
  //       }
  //     });
  //   } else {
  //     if (!username) {
  //       this.setState({ emptyUsernameError: true,errorMessage: 'Username is empty, Enter Username ' });
  //     }
  //     if (!password) {
  //       this.setState({ emptyPasswordError: true,errorMessage: 'Password is empty, Enter Password '  });
  //     }

  //   }

  // }

  handleLogin = (e) => {
    e.preventDefault();
    console.log('handle calling')

    const { username, password } = this.state;
    if (password && username) {
      this.setState({ isLoading: true, disabled: true });
      this.props.loginAPI({
        username: this.state.username,
        password: this.state.password
      }, (res, err) => {
        
        console.log('handle login response',res.data)
        if (res) {

        this.setState.termsAccepted=res.data.termsAccepted
        this.setState.userType=res.data.userType
        // this.setState.groupId=res.data.groupId
        this.setState.userId=res.data.userId

    console.log('login check qwertyu 123',this.state.termOpen,res.data.termsAccepted,this.setState.userType)

    if (res.data.termsAccepted === null ) {
      this.setState({
          termOpen:true,
          isLogging: false,
         userType:res.data.userType,
         userId:res.data.userId,
        //  groupId:sessionStorage.getItem('imark-groupId')
      });
      console.log('handle login termaccepted if equal to null calling',this.state.termOpen,this.state.isLogging,this.state.userType,this.state.userId,this.state.groupId)

  }


          if(res.status === 200 ){

        console.log('response if',res.data,this.setState.termsAccepted,this.setState.userType);
        console.log("chkkkthissssssssssss",res.data.groupId)


        let userInfo = jwt(res.data.jwtToken)
            userInfo.roleTest="Vendor";
        localStorage.setItem('imark-token', `Bearer ${res.data.jwtToken}`);
             console.log("imark-token",localStorage.getItem("imark-token"));
             localStorage.setItem("flag","1");
             localStorage.setItem("imark-userType", res.data.userType);
             localStorage.setItem("imark-userInfo",JSON.stringify(userInfo));
             localStorage.setItem("imark-groupId",res.data.groupId);
             localStorage.setItem("imark-userId", res.data.userId);
             localStorage.setItem("imark-Name",res.data.firstName);
         localStorage.setItem("imark-termAccepted",res.data.termsAccepted)

        sessionStorage.setItem('imark-token', `Bearer ${res.data.jwtToken}`);
             sessionStorage.setItem("imark-buyingGroupId", res.data.buyingGroupId);
             sessionStorage.setItem("imark-memberId", res.data.groupId);
             sessionStorage.setItem("imark-vendorId", res.data.groupId);
             localStorage.setItem("buyingGroupId", res.data.buyingGroupId);
             localStorage.setItem("imark-memberId", res.data.groupId);
             localStorage.setItem("imark-vendorId", res.data.groupId);
             sessionStorage.setItem("imark-memberName", res.data.groupName);
             sessionStorage.setItem("imark-vendorName", res.data.groupName);
         sessionStorage.setItem("imark-termAccepted",res.data.termsAccepted)
         sessionStorage.setItem("imark-userType", res.data.userType);
         sessionStorage.setItem("imark-groupId",res.data.groupId);
         console.log('localStorage',localStorage);
             console.log('flag',localStorage.getItem('flag'));
             //axios.defaults.headers.common['Authorization'] = "Bearer " + res.token;
        console.log(res);
             axios.defaults.headers.common['Authorization'] = "Bearer " + res.data.jwtToken;
        // this.props.history.push('/');

        if (res.data.termsAccepted !== null ){
          this.setState({
                    termOpen:false,
                    isLogging: false,
                   userType:res.data.userType,
                   userId:res.data.userId,
                  //  groupId:localStorage.getItem('imark-groupId')
                });
                console.log('handle login termaccepted if not to null calling',this.state.termOpen,this.state.isLogging,this.state.userType,this.state.userId,this.state.groupId)
          }

        // else{
        //   this.setState({
        //     termOpen:true,
        //     isLogging: false,
        //    userType:res.data.userType,
        //    userId:res.data.userId,
        //    groupId:sessionStorage.getItem('imark-groupId')
        // });
        // console.log('termaccepted if equal to null calling',this.state.termOpen,this.state.isLogging,this.setState.userType,this.setState.userId,this.setState.groupId)
        // }



       }
      }
       else if (err) {
          this.setState({ errorMessage:"Error while logging , please provide correct credentials" });
        }
      });
      }
    }


  renderModal() {
    if (this.state.displayModal) {
      let { propsForModal } = this.state;
      return (
        <Modal modalType="error" propsForModal={propsForModal} closeModal={this.closeModal} />
      )
    } else {

    }
  }

  handleForgotPassword = () => {
      this.props.history.push("/forgot_password")
  }
  closeTermsModal = () => {
    localStorage.clear();
    this.props.disagreeTermsAPI({ userId: this.state.userId}).then((res, err) => {
        this.setState({ termOpen: false, termsAccepted: false });
        setTimeout(() => {
            // window.location('https://inside.imarkgroup.com/')
            window.location('https://inside.imarkplumbing.com/')
        }, 2000);
    });

  }
acceptTerms = (nextUrl) => {
  console.log('Accept Terms User ID', this.state.userId);
  this.props.acceptTermsAPI({ userId: this.state.userId }).then((res, err) => {
      // this.setState({ termOpen: false, termsAccepted: true, termsAcceptedAt: new Date().getTime() },()=>this.props.history.push(nextUrl))
      this.setState({ termOpen: false, termsAccepted: true, termsAcceptedAt: new Date().getTime() })
      this.props.history.push(nextUrl);
      console.log('next url',nextUrl)
  });
}





  render() {
    console.log('login check1',this.state.termOpen,this.state.termsAccepted,this.state.userType);
    // console.log('rendor checks groupid',this.state.groupId)
    // console.log('login check1',this.state.showTncBox,this.state.userType,this.state.termsAccepted);
    let {
       termOpen,
    } = this.state;

    if (this.state.termsAccepted === null  && this.state.userType ==='CORPORATE'  ) {
      if (termOpen) {
          return <div className='modal fade show' tabIndex='-1' role='dialog' style={{ display: 'block' }}>
            {console.log('termopen if block',termOpen)}
              <TermsOfUse acceptTerms={() => this.acceptTerms('/Corporate/Overview')} closeModal={this.closeTermsModal} />
          </div>

      }
      else {
        return<Redirect to={'/Corporate/Overview'} />
      }
  }
  else if (this.state.termsAccepted === null && this.state.userType === 'MEMBER') {
    if (termOpen) {
        return <div className='modal fade show' tabIndex='-1' role='dialog' style={{ display: 'block' }}>
            {console.log('member groupId',this.state.groupId)}
            {console.log('member if return',termOpen)}
            {/* <TermsOfUse acceptTerms={() => this.acceptTerms("/member/" + this.state.groupId+ "/MemberData")} closeModal={this.closeTermsModal} /> */}
            <TermsOfUse acceptTerms={() => this.acceptTerms("/member/MemberData")} closeModal={this.closeTermsModal} />

        </div>
    }
    else {
      {console.log('member else return',termOpen)}
        // return <Redirect to={"/member/" + this.state.groupId+ "/MemberData"} />
        return <Redirect to={"/member/MemberData"} />

    }
}
else if (this.state.termsAccepted === null && (this.state.userType === 'VENDOR' || this.state.userType === 'SUPPLIER')) {
    if (termOpen) {
        return <div className='modal fade show' tabIndex='-1' role='dialog' style={{ display: 'block' }}>
          {console.log('supplier groupId',this.state.groupId)}
            {/* <TermsOfUse acceptTerms={() => this.acceptTerms("/supplier/" + this.state.groupId + "/overview")} closeModal={this.closeTermsModal} /> */}
            <TermsOfUse acceptTerms={() => this.acceptTerms("/supplier/overview")} closeModal={this.closeTermsModal} />

        </div>
    } else {
        // return <Redirect to={"/supplier/" + this.state.groupId + "/overview"} />
        return <Redirect to={"/supplier/overview"} />
    }
}
// else
// {

    return (
      <div>
        <nav className=" Filters navbar">
          <div className="imgContainer" style={{ marginLeft: "20px" }}>
          {/* <h3 style= {{marginLeft: '50px',"font-family": 'Fantsy', color: 'rgb(255, 127, 14)' , 'font-size':' xx-large' ,'font-variant': 'proportional-nums','text-decoration': 'underline','textDecorationStyle': "double"}} >Rebate.ai</h3> */}
                                  <img height="35" 
            src={process.env.PUBLIC_URL + '/IMARK Logo.png'} alt="img  " />
          </div>
        </nav>
        {this.renderModal()}
        <main class="markLogin" style={{ backgroundImage: this.state.imageUrl }}>
          <form className="form-signin" autocomplete="off">
            <h3 className="mt-5 h3 mb-3 font-weight-normal desc">{this.props.message}</h3>
            <label for="inputEmail" className="sr-only">Email address</label>
            <input style={{ border: this.state.emptyUsernameError ? this.state.border : "" }} type="email" id="inputEmail" className="form-control" placeholder="Email address" required="" autofocus="" onChange={(e) => { this.setState({errorMessage:'', username: e.target.value, emptyUsernameError: false }) }} />
            <label for="inputPassword" className="sr-only">Password</label>
            <input style={{ border: this.state.emptyPasswordError ? this.state.border : "" }} type="password" id="inputPassword" className="form-control" placeholder="Password" required="" onChange={(e) => { this.setState({errorMessage:'', password: e.target.value, emptyPasswordError: false }) }} />
    <span style={{color:"red"}}>{this.state.errorMessage}</span>
            <div className="row loginRow">
              <div className="col-6">
                <button className="btn btn-md btn-primary btn-block"  onClick={(e) => this.handleLogin(e)}>Log in</button>
              </div>
              <div className="col-6">
                {/* <button onClick={this.handleForgotPassword} className="btn btn-md btn-success btn-block" >Forgot Password</button> */}
              </div>
            </div>


          </form>
        </main>
      </div>
    )
// }
  }
}

function mapStateToProps(state) {
  return {
    authenticationDetails: state.userAuthentication,
  }
}

export default connect(mapStateToProps, {
  loginAPI: login,
  ssoLoginAPI: tokenLogin,
  acceptTermsAPI: acceptTerms,
  disagreeTermsAPI: disagreeTerms,

})(Login);